import { Box, Typography } from "@mui/material";
import IMessage from "../../../../interface/IMessage";

const RenderMessageSystem = ({
  message,
}: {
  message: IMessage;
}): React.JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
        my: 1,

        borderRadius: "10px",
      }}
    >
      <Typography
        variant="caption"
        color="initial"
        sx={{
          textAlign: "center",

          fontWeight: "bold",
        }}
      >
        {message.text}
      </Typography>
    </Box>
  );
};

export default RenderMessageSystem;
